import { ServerListResponse } from '@lumapps/base-api';
import { useInfiniteQuery } from '@lumapps/base-api/react-query';
import { listUserReactions } from '@lumapps/reactions-core/api';
import { reactionsQueryKeys } from '@lumapps/reactions-core/api/query';
import type { ReactionResourceRef, ReactionType, UserReactions } from '@lumapps/reactions-core/api/types';

import { REACTION_USER_LIST_DIALOG_MAX_RESULTS } from '../constants';

const BASE_PAGE_PARAMS = { maxResults: REACTION_USER_LIST_DIALOG_MAX_RESULTS };

export const useReactionUserListDialog = (
    resourceRef: ReactionResourceRef,
    enabled: boolean,
    currentReaction?: ReactionType,
) =>
    useInfiniteQuery({
        queryKey: reactionsQueryKeys.listReactions(resourceRef, { ...BASE_PAGE_PARAMS, reactionType: currentReaction }),
        queryFn: ({ pageParam }) =>
            listUserReactions(resourceRef, { ...BASE_PAGE_PARAMS, reactionType: currentReaction, ...pageParam }),
        getNextPageParam: ({ cursor, more }: ServerListResponse<UserReactions>) => more && { cursor, more },
        staleTime: Infinity,
        enabled,
    });
